document.addEventListener('DOMContentLoaded', function() {
    // Select the Add to Cart form
    const addToCartForm = document.querySelector('form.product-form');
    
    if (addToCartForm) {
        addToCartForm.addEventListener('submit', function(e) {
            e.preventDefault(); // Prevent the default form submission

            // Get the product ID and quantity from the form
            const formData = new FormData(addToCartForm);
            const productId = formData.get('id');
            const quantity = formData.get('quantity') || 1;

            // Send the product to the cart using AJAX
            fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify({
                    id: productId,
                    quantity: quantity
                })
            })
            .then(response => response.json())
            .then(data => {
                console.log('Product added to cart:', data);
                alert('Product added to cart!'); // Optional confirmation message
                // You could also update the cart icon or display a mini-cart here
            })
            .catch(error => {
                console.error('Error adding to cart:', error);
            });
        });
    }
});
